import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

// Import translations using require to avoid JSON import issues
const enTranslations = require('./locales/en.json');
const jaTranslations = require('./locales/ja.json');

const resources = {
  en: {
    translation: enTranslations,
  },
  ja: {
    translation: jaTranslations,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: 'ja', // Explicitly set default language to Japanese
    fallbackLng: 'ja',
    debug: process.env.NODE_ENV === 'development',

    interpolation: {
      escapeValue: false, // React already escapes values
    },

    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
      lookupSessionStorage: 'i18nextLng',
    },

    // Ensure language is properly initialized
    initImmediate: false,
  });

// Update HTML lang attribute when language changes
i18n.on('languageChanged', lng => {
  document.documentElement.lang = lng;
});

export default i18n;
